'use client';

import { useTranslationStore } from '@/stores';
import { useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation as t } from '../../../hooks/useTranslation';
import { IEpSelectOptionsListData } from '../../../interfaces';
import { EpStepContent, EpStepSelect } from '../components';

export default function PatientGenderId({
  translations,
  isPharmacy = false,
}: {
  translations: unknown;
  isPharmacy?: boolean;
}) {
  const { setValue } = useFormContext();
  const PersonValue = useWatch({ name: 'person.inputValue' });
  const NoId = useWatch({ name: 'noId' });
  const personType = useWatch({ name: 'personType.inputValue' });
  const activeStep = useWatch({ name: 'formUtils.activeStep' });
  const checkIfIsPersonValid =
    (PersonValue === 'true' || PersonValue === undefined) && !!NoId;
  const checkIfIsPersonType = personType && personType !== '1';
  const isVisible = checkIfIsPersonValid || checkIfIsPersonType || isPharmacy;

  const GenderMock: IEpSelectOptionsListData[] = [
    {
      id: 1,
      name: t(translations, 'Male'),
      label: '',
      value: '',
    },
    {
      id: 2,
      name: t(translations, 'Female'),
      label: '',
      value: '',
    },
    {
      id: 3,
      name: t(translations, 'Unknown / Not declared'),
      label: '',
      value: '',
    },
  ];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [GenderOptionItens] = useState<IEpSelectOptionsListData[]>(GenderMock);
  const { translations: global } = useTranslationStore();

  // function handleChange() {
  //   resetField('unitId.inputValue');
  //   resetField('unitId.inputLabel');
  // }

  useEffect(() => {
    if (personType && activeStep === '1') {
      setValue('genderId.inputValue', undefined);
      setValue('genderId.inputLabel', undefined);
    }
  }, [activeStep, personType, setValue]);

  if (!isVisible) return null;

  if (!GenderOptionItens || GenderOptionItens.length === 0) {
    return null;
  }

  return (
    <>
      <EpStepContent.Label label={t(translations, 'Gender')}>
        <EpStepSelect
          required={false}
          //customLabelValue={['label', 'value']}
          // selectOnChange={handleChange} @TODO - Corrigir função Callback de EpSelect.
          data={GenderMock}
          errorMessage={t(global['global'], '* Required Fied')}
          registerId={'genderId'}
        />
      </EpStepContent.Label>
    </>
  );
}
